import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from '@sentry/react';
import { initSentry } from './sentry';

initSentry();

const SentryApp = Sentry.withProfiler(App);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={({ error }) => <p>Something went wrong: {error?.message}</p>}>
    <SentryApp />
  </Sentry.ErrorBoundary>
);

